import { useGetTicketsQuery } from '@/queries/useGetTicketsQuery';

export const useTickets = () => {
  const { data: ticketsData, isLoading } = useGetTicketsQuery();

  if (isLoading) {
    return { ticketsData: [], isLoading };
  }

  return { ticketsData };
};
